import { StatusBar } from 'expo-status-bar'
import { useThemeStore } from '../lib/stores/theme.store'

/**
 * Renders an expo-status-bar whose icon style matches the active theme.
 * Place this once in app/_layout.tsx, inside ThemeProvider.
 *
 * Dark mode → light status bar text (white icons)
 * Light mode → dark status bar text (black icons)
 */
export function ThemedStatusBar() {
  const resolvedTheme = useThemeStore((s) => s.resolvedTheme)
  const isDark = resolvedTheme === 'dark'

  return <StatusBar style={isDark ? 'light' : 'dark'} />
}
